/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PROAUTH", "88")




export interface API42491Req {
  
  /** 微信临时授权码 */
  code?: string;
  /** 平台 */
  platform?: string;
};



export interface API42491Res {
  /** 是否切换为新平台  */
  isNewPlatform?: boolean;
  /** 用户id  */
  userId?: string;
  /** 用户姓名  */
  userName?: string;
  /** 项目名称  */
  userPhone?: string;
  /** 备注  */
  remark?: string;
  /** 邮箱  */
  userEmail?: string;
  /** 用户登录token  */
  userToken?: string;
  /** 是否是灰度用户  */
  isBeta?: boolean;
  /** 是否服务灰度  */
  isGray?: boolean;
  
};


// 42491 通过微信code获取用户数据

export interface IUsePostAPI42491Return {
  /** 通过微信code获取用户数据: 接口请求状态 */
  isAPI42491Loading: boolean;
  /** 通过微信code获取用户数据: 接口请求返回数据 */
  dataAPI42491: API42491Res;
  /**  通过微信code获取用户数据: 接口数据请求方法 */
  fetchAPI42491Data:  (inputs: API42491Req, config?: YWRequestConfig) => Promise<API42491Res>;
  /** 通过微信code获取用户数据: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI42491 = ():IUsePostAPI42491Return => {
  let isMount = true;
  const [isAPI42491Loading, setIsAPI42491Loading] = useState(false);
  const [dataAPI42491, setDataAPI42491] = useState<API42491Res>({} as API42491Res);
  const requestUrl = `${basePath}/ywwl-admin/wx/code/login`;

  const fetchAPI42491Data = async (inputs: API42491Req, config?: YWRequestConfig): Promise<API42491Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API42491Req>) || {}) as API42491Req;
    
  
    if ( isMount ) {
      setIsAPI42491Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API42491Res>(`${basePath}/ywwl-admin/wx/code/login`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI42491(res || {} as API42491Res);
        setIsAPI42491Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI42491Loading(false);
      }
      return false as unknown as API42491Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI42491Loading,
    dataAPI42491,
    fetchAPI42491Data,
    requestUrl,
  }
}

